import React from 'react';
import PropTypes from 'prop-types';
import DispatchTableHead from './TableHead';

class DispatchTableNote extends React.Component {
  handleOpenModal = modalData => {
    const { handleOpenItemModal } = this.props;
    const content = this.modalContent(modalData);
    handleOpenItemModal(content);
  };

  handleCloseModal = () => {
    const { handleCloseItemModal } = this.props;
    handleCloseItemModal();
  };

  modalContent = modalData => {
    if (!modalData) {
      return;
    }
    return (
      <div className="details">
        <div className="note">
          <label className="control-label">Note :</label>
          <pre>{modalData}</pre>
        </div>
      </div>
    );
  };

  render() {
    const {
      note,
      handleToggleItemModal,
      handleDeleteClick,
      copyType,
      handleCopy,
      handlePaste,
      userType,
    } = this.props;
    return (
      <React.Fragment>
        <table className="notes">
          <DispatchTableHead
            title="notes"
            span={2}
            onAddClick={() => handleToggleItemModal(4)}
            active={copyType === 'note'}
            userType={userType}
            onOptionClick={() =>
              copyType === 'note' ? handlePaste() : handleCopy()
            }
          />
          <tbody>
            {note ? (
              <tr>
                <td onClick={() => this.handleOpenModal(note)}>{note}</td>
                {userType === 'admin' && (
                  <td
                    className="delete-icon"
                    onClick={() => handleDeleteClick()}
                  >
                    <i className="fa fa-times" aria-hidden="true" />
                  </td>
                )}
              </tr>
            ) : (
              <tr />
            )}
          </tbody>
        </table>
      </React.Fragment>
    );
  }
}

DispatchTableNote.propTypes = {
  team: PropTypes.object,
  handleToggleItemModal: PropTypes.func,
  handleDeleteClick: PropTypes.func,
};

export default DispatchTableNote;
